export const spacing = (values)=>{
    const { bottom, full, left, right, top, x, y } = values;
    return [
        [
            full
        ],
        [
            y,
            x
        ],
        [
            top,
            right,
            bottom,
            left
        ]
    ].find((values)=>values.some((value)=>value || value === 0))?.map((value)=>value || 0).join(' ');
};

//# sourceMappingURL=Box.helpers.js.map